module.exports = __webpack_public_path__ + "static/HeroDuctlessImage-c41f49e7d9fbf06028aec757047f8b0c.jpeg";